import Vue from 'vue'
import Router from 'vue-router'

import SignPage from '@/view/signPage'
import SubmitPage from '@/view/submitPage'
import OrgNamePage from '@/view/orgNamePage'
import ResultPage from '@/view/resultPage'

Vue.use(Router)

const routes = [
  { path: '/sign', component: SignPage, name: 'SignPage' },
  { path: '/submit', component: SubmitPage, name: 'SubmitPage' },
  { path: '/orgName', component: OrgNamePage, name: 'OrgNamePage' },
  { path: '/result', component: ResultPage, name: 'ResultPage' },
  { path: '/', redirect: '/sign' }
]

var router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({
      name: from.name
    }) : next('/sign/:meetingId')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js